export function HandoverItemViewConstructor(services, callbacks, context, siteTypeConfig) {
  
  let joint = services.joint;

  return joint.shapes.html.AbstractElementView.extend({

    template: [
      '<div class="html-element handover-item">',
      '<span class="handover-item-description" style="color: #FF59C4; line-height: 30px;"></span>',
      '<div class="handover-edit-container"><span class="glyphicon glyphicon-pencil handover-edit"></span></div>',
      '</div>'
    ].join(''),

    initialize: function() {
      joint.shapes.html.AbstractElementView.prototype.initialize.apply(this, arguments);

      // Hook edition icon click handler (this.$box is initialized by the abstract superclass)
      this.$box.find('.handover-edit').on('click', () => this.editHandoverItem());
    },

    // Event handler that shows a modal dialog for editing a custom take-over condition
    editHandoverItem: function(evt) {

      let parent = this.model.getAncestors()[0];
      let modalInstance = services.$uibModal.open({
        animation: true,
        template:  require('./editHandoverItem.modal.html'),
        controller: 'editHandoverItemController',
        resolve: {
          handoverItem: {
            handoverType: this.model.get('handoverType'),
            metadata: this.model.get('data'),
            description: this.model.get('description'),
            timeout: parent.get('timeout')
          }
        }
      });
      modalInstance.result.then(result => this.afterEditHandoverItem(result));
    },

    // private method called when the modal is closed and a result is resolved
    afterEditHandoverItem: function (result) {
      let parent = this.model.getAncestors()[0];
      let parentView = this.paper.findViewByModel(parent);
      if(result.type === 'delete') {
        this.model.remove();
        //we save the graph on remove cell event

      } else if (result.type === 'edit') {
        this.model.set('handoverType', result.data.handoverType);
        if (result.data.handoverType === 'timeout') {
          // timeout is stored at the handover level
          parent.set('timeout', result.data.timeout);
        } else {
          this.model.set('data', result.data.metadata);
          this.model.set('description', result.data.description);
        }
        callbacks.updateSerializedGraph(this.model.graph);
      }
      //Resize needed for both editing and deleting
      parentView.resizeBox();
    },

    updateBox: function() {
      joint.shapes.html.AbstractElementView.prototype.updateBox.apply(this, arguments);
      if(this.paper) {
        // Update item label
        this.$box.find('.handover-item-description').text(this.model.get('description'));
      }
    },

  });
}
